const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roleName: state => state.user.roleName,
  roleGuid: state => state.user.roleGuid,
  orgGuid: state => state.user.orgGuid,
  routerList: state => state.user.RouterList,
  roles: state => state.user.roles,
  perms: state => state.user.perms,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js